export const formatBoolean = (value?: boolean) => value ? 'Yes' : 'No';

export const formatEnumValue = (value?: string) => value
    ? value
            .toLowerCase()
            .split('_')
            .map(part => part.charAt(0).toUpperCase() + part.slice(1))
            .join(' ')
    : '--';
